define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/generator", "../../models/LocationModel", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, generator_1, LocationModel, UserContext) {
    "use strict";
    var OfficeLocationActions = /** @class */ (function () {
        function OfficeLocationActions() {
            this.editLocationModel = ko.observable(new LocationModel());
            this.userCanUpdateDns = ko.observable(UserContext.hasAccess("Admin,Dns.Edit,Dns.Delete"));
            this.userCanDeleteDns = ko.observable(UserContext.hasAccess("Admin,Dns.Delete"));
            this.deleteDns = ko.observable(false);
            this.allowEditAddress = ko.observable(true);
            this.dnsInfo = ko.observable();
            this.dnsInfoText = ko.observable("");
            this.canUpdateDns = false;
        }
        OfficeLocationActions.prototype.init = function () {
        };
        OfficeLocationActions.prototype.showDynDnsInfo = function () {
            var self = this;
            return self.userCanUpdateDns() && self.dnsInfo() && self.dnsInfo().DnsProvider === "DynDns";
        };
        OfficeLocationActions.prototype.editCustomerLocation = function (locationId, customerId, customerName, locationAddress) {
            var self = this;
            self.editLocationModel(new LocationModel());
            self.dnsInfo = ko.observable();
            var title = locationId ? "Edit Customer Location" : "Add Customer Location";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (!self.editLocationModel().Address()) {
                        tools.error('Physical Address is a required field');
                        return;
                    }
                    if (self.editLocationModel().UpdateDns() && self.showDynDnsInfo() && !self.editLocationModel().IpAddress()) {
                        tools.error('IP address is a required field');
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCustomerLocation(event.currentTarget, modal);
                },
                opened: function (modal) {
                    self.dnsInfoText("");
                    var getModelCall = null;
                    if (!isNaN(locationId)) {
                        getModelCall = tools.ajaxGet({
                            url: urls_1.urls.getCustomerLocationById,
                            data: { id: locationId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editLocationModel(new LocationModel(result.Data));
                                    self.editLocationModel().DnsDomain.subscribe(function (value) {
                                        self.checkDomainName();
                                    });
                                    self.editLocationModel().DnsName.extend({ rateLimit: { timeout: 300, method: "notifyWhenChangesStop" } });
                                    self.editLocationModel().DnsName.subscribe(function (value) {
                                        self.checkDomainName();
                                        self.editLocationModel().DynDnsUsername("997As5-R".concat(self.editLocationModel().DnsName()));
                                    });
                                    self.editLocationModel().UpdateDns.subscribe(function (value) {
                                        self.checkDomainName();
                                    });
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editLocationModel(new LocationModel());
                        self.editLocationModel().CustomerId(customerId);
                        self.editLocationModel().CustomerName(customerName);
                        self.editLocationModel().Address(locationAddress);
                        self.editLocationModel().DnsDomain("tgremote.com");
                        self.editLocationModel().LocationType.subscribe(function (value) {
                            if (value == "2" /*External Server*/ && !self.editLocationModel().ServerId()) {
                                self.editLocationModel().DnsDomain("tgpbx.com");
                            }
                        });
                        self.editLocationModel().DnsDomain.subscribe(function (value) {
                            self.checkDomainName();
                        });
                        self.editLocationModel().DnsName.extend({ rateLimit: { timeout: 300, method: "notifyWhenChangesStop" } });
                        self.editLocationModel().DnsName.subscribe(function (value) {
                            self.checkDomainName();
                            self.editLocationModel().DynDnsUsername("997As5-R".concat(self.editLocationModel().DnsName()));
                        });
                        self.editLocationModel().UpdateDns.subscribe(function (value) {
                            self.checkDomainName();
                        });
                    }
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: "/OfficeLocations/GetLookupData",
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    var getDnsCall = null;
                    if (!locationId) {
                        getDnsCall = self.checkDomainName();
                    }
                    $.when(getModelCall, getLookupData, getDnsCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customerlocation-edit-template', data: editLocationModel }\"></div>");
                        if (self.editLocationModel().Address() || self.editLocationModel().Id() > 0) {
                            self.allowEditAddress(true);
                        }
                        else {
                            self.allowEditAddress(true);
                        }
                        ko.applyBindings(self, modal);
                        var preselectServer = false;
                        $(".dropdown-menu li", modal).click(function (e) {
                            var selected = $(this).data("domain");
                            self.editLocationModel().DnsDomain(selected);
                            self.serversDropDownList.search(selected);
                            preselectServer = true;
                            e.preventDefault();
                        });
                        self.serversDropDownList = $("#ServerId", modal).kendoComboBox({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            placeholder: "Select server...",
                            dataTextField: "IpAddress",
                            dataValueField: "Id",
                            dataSource: {
                                transport: {
                                    read: {
                                        url: "/Servers/GetServersLookup",
                                        type: "POST",
                                        dataType: "json"
                                    }
                                },
                                schema: {
                                    data: function (response) { return response.Data; },
                                    total: "Total"
                                },
                                serverFiltering: true,
                            },
                            dataBound: function () {
                                console.log('dataBound', self.serversDropDownList.dataSource.data());
                                if (preselectServer) {
                                    preselectServer = false;
                                    self.serversDropDownList.close();
                                    self.serversDropDownList.select(0);
                                }
                            },
                            cascade: function (e) {
                                if (self.serversDropDownList.dataItem()) {
                                    self.dnsInfo(self.serversDropDownList.dataItem().DnsInfo);
                                    self.editLocationModel().ServerId(self.serversDropDownList.dataItem().Id);
                                    self.editLocationModel().DnsDomain(self.dnsInfo().DnsZoneName);
                                    if (self.dnsInfo().DnsProvider === "DynDns" && !self.editLocationModel().UserPassword()) {
                                        self.editLocationModel().UserPassword(self.generatePassword());
                                    }
                                }
                                else {
                                    if (self.editLocationModel().ServerId()) {
                                        self.dnsInfo(undefined);
                                        self.editLocationModel().ServerId(null);
                                        self.editLocationModel().DnsDomain(undefined);
                                        self.editLocationModel().UserPassword(null);
                                    }
                                }
                            }
                        }).data("kendoComboBox");
                        self.serversDropDownList.wrapper.width("100%");
                        self.serversDropDownList.value(self.editLocationModel().ServerId());
                        self.editLocationModel().UpdateDns.subscribe(function () {
                            self.serversDropDownList.enable(self.editLocationModel().UpdateDns());
                            if (self.editLocationModel().UpdateDns()) {
                                self.serversDropDownList.search(self.editLocationModel().DnsDomain());
                                preselectServer = true;
                            }
                        });
                        self.serversDropDownList.enable(self.editLocationModel().UpdateDns());
                        $(function () {
                            $('[data-toggle="tooltip"]', modal).tooltip();
                        });
                    });
                }
            });
        };
        OfficeLocationActions.prototype.checkDomainName = function () {
            var self = this;
            if (self.checkDomainRequest && self.checkDomainRequest.readyState != 4) {
                self.checkDomainRequest.abort();
                log.log("request aborted");
            }
            $("#dnsDomainHolder").removeClass("has-warning").removeClass("has-success").removeClass("has-error");
            self.dnsInfoText("");
            if (!self.editLocationModel().UpdateDns()) {
                return null;
            }
            $("#dnsCheckLoader").show();
            var request = tools.ajaxGet({
                url: "/CustomerLocations/CheckDomainNameJson",
                data: {
                    CustomerId: self.editLocationModel().CustomerId(),
                    domainName: self.editLocationModel().DnsDomain(),
                    dnsName: self.editLocationModel().DnsName() ? self.editLocationModel().DnsName().toLowerCase() : "",
                    locationId: self.editLocationModel().Id(),
                    useAccountNumber: true,
                    usePrefix: true
                },
                success: function (result) {
                    if (result.Success) {
                        log.log(result.Data);
                        $("#dnsDomainHolder").removeClass("has-warning").removeClass("has-success").removeClass("has-error");
                        self.dnsInfoText("");
                        if (!self.editLocationModel().DnsName() && result.Data.suggestedDnsName) {
                            self.editLocationModel().DnsName(result.Data.suggestedDnsName.toLowerCase());
                        }
                        if (result.Data.currentDnsValid && result.Data.suggestedDnsNameIpAddress) {
                            $("#dnsDomainHolder").addClass("has-warning");
                            self.canUpdateDns = true;
                            self.dnsInfoText("Subdomain is available to create in BO system but subdomain already has assigned IP address ("
                                + result.Data.suggestedDnsNameIpAddress
                                + ")."
                                + (result.Data.moreInfo.DnsDetails ? "<br/><strong>" + result.Data.moreInfo.DnsDetails + "</strong><br/>" : "")
                                + "Subdomain will be updated if server and DNS info are provided");
                        }
                        else if (result.Data.currentDnsValid && !result.Data.suggestedDnsNameIpAddress) {
                            $("#dnsDomainHolder").addClass("has-success");
                            self.canUpdateDns = true;
                            self.dnsInfoText("Subdomain is available to create");
                        }
                        else {
                            $("#dnsDomainHolder").addClass("has-error");
                            self.canUpdateDns = false;
                            self.dnsInfoText("Subdomain is in use."
                                + (result.Data.currentMoreInfo.DnsDetails ? "<br/><strong>" + result.Data.currentMoreInfo.DnsDetails + "</strong><br/>" : "")
                                + " Suggested name to use: " + result.Data.suggestedDnsName);
                        }
                    }
                    else {
                        log.error(result.Error);
                    }
                }
            });
            request.always(function () {
                $("#dnsCheckLoader").hide();
            });
            self.checkDomainRequest = request;
            return request;
        };
        OfficeLocationActions.prototype.generatePassword = function () {
            return generator_1.RandomGenerator.generate({
                Length: 10,
                Type: 'Length',
                IncludeLowercase: true,
                IncludeNumbers: true,
                IncludeUppercase: true,
                IncludeSpecial: false
            });
        };
        OfficeLocationActions.prototype.generatePasswordClick = function (data, event) {
            var self = this;
            self.editLocationModel().UserPassword(self.generatePassword());
            event.preventDefault();
        };
        OfficeLocationActions.prototype.saveCustomerLocation = function (btn, modal) {
            var _this = this;
            var self = this;
            /*if (self.editLocationModel().UpdateDns() && self.canUpdateDns) {
                tools.error('Fix DNS errors first');
                return;
            }*/
            var selectedServer = self.serversDropDownList.dataItem();
            if (selectedServer) {
                self.editLocationModel().ServerId(selectedServer.Id);
            }
            else {
                self.editLocationModel().ServerId(null);
            }
            if (self.editLocationModel().DnsName()) {
                self.editLocationModel().DnsName(self.editLocationModel().DnsName().toLowerCase());
                self.editLocationModel().Dns(self.editLocationModel().DnsName().toLowerCase() + "." + self.editLocationModel().DnsDomain().toLowerCase());
            }
            var obj = ko.mapping.toJS(self.editLocationModel);
            obj["__RequestVerificationToken"] = $('#mainCustomerForm input[name="__RequestVerificationToken"]').val();
            obj["newAddress"] = self.allowEditAddress();
            tools.ajaxPost({
                url: "/OfficeLocations/SaveCustomerLocation",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (_this.saveCallback) {
                        _this.saveCallback();
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        OfficeLocationActions.prototype.deleteLocationConfirm = function (locationId) {
            var self = this;
            self.deleteDns(false);
            tools.editModal({
                title: "Delete Customer Location",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.deleteLocation(locationId, self.deleteDns());
                    $(event.currentTarget).button("reset");
                    $(modal).modal("hide");
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'officelocation-remove-template', data: $root }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        OfficeLocationActions.prototype.deleteLocation = function (locationId, deleteDns) {
            var _this = this;
            var data = {
                id: locationId,
                deleteDns: deleteDns
            };
            data["__RequestVerificationToken"] = $('#mainCustomerForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/OfficeLocations/DeleteOfficeConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Location deleted successfully");
                    if (_this.deleteCallback) {
                        _this.deleteCallback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
            });
        };
        OfficeLocationActions.prototype.restoreLocationConfirm = function (locationId) {
            var _this = this;
            tools.confirmModal({
                title: "Restore Customer Location",
                text: "Are you sure you want to restore customer location?",
                buttonTitle: "Restore",
                type: "danger",
                modalOptions: {},
            }, function (modal) {
                $(modal).modal("hide");
                _this.restoreLocation(locationId);
            });
        };
        OfficeLocationActions.prototype.restoreLocation = function (locationId) {
            var _this = this;
            var data = {
                id: locationId
            };
            data["__RequestVerificationToken"] = $('#mainCustomerForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/OfficeLocations/RestoreOfficeConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Location restored successfully");
                    if (_this.deleteCallback) {
                        _this.deleteCallback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
            });
        };
        return OfficeLocationActions;
    }());
    return OfficeLocationActions;
});
//# sourceMappingURL=officeLocationActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/officeLocations/officeLocationActions.js
// module id = 195
// module chunks = 2